import React from "react";
import "./MovementGuideModal.css";
import { resolveGuideAssetUrl } from "../../utils/resolveGuideAssetUrl";

const MovementGuideModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="movement-guide-modal-overlay" onClick={onClose}>
      <div className="movement-guide-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="movement-guide-close-button app-cancel-control" onClick={onClose}>✖</button>
        <img
          src={resolveGuideAssetUrl("/assets/Map-Legend.png")}
          alt="Movement Guide"
          className="movement-guide-image"
        />
      </div>
    </div>
  );
};

export default MovementGuideModal;
